import React, { useState } from 'react'
import { parseMillisecondsToHoursAndMinutes } from '../../../helpers/helpers'
import { Spinner } from 'reactstrap'
import PermanenceTotalsDetailModal from './PermanenceTotalsDetailModal'
import { t } from 'i18next'

const PermanenceTotals = ({ haveDetail = true, borders = 'border border-primary', totals, isFetching = false, alingment = 'justify-content-around' }) => {

    const [showModal, setShowModal] = useState(false);

    return (
        <>
            <PermanenceTotalsDetailModal
                showModal={showModal}
                setShowModal={() => setShowModal(!showModal)}
            />
            <div className='position-relative'>
                <div className={`d-flex ${alingment} align-items-center flex-wrap ${borders} bg-white rounded`}>
                    <div className='text-center'>
                        <span
                            className={`subtitle text-nowrap ${isFetching && ('d-block')}`}
                        >
                            {t('NORMAL_HS')}
                        </span>
                        {
                            isFetching ?
                                <Spinner />
                                :
                                <h4
                                    className='blue-text text-nowrap'
                                    style={{ fontSize: '15px' }}
                                >
                                    {Number(parseMillisecondsToHoursAndMinutes(totals.hs_normal).split(':')[0])}hs {Number(parseMillisecondsToHoursAndMinutes(totals.hs_normal).split(':')[1])}min
                                </h4>
                        }
                    </div>
                    <div className='text-center'>
                        <span
                            className={`subtitle text-nowrap ${isFetching && ('d-block')}`}
                        >
                            {t('50%_HS')}
                        </span>
                        {
                            isFetching ?
                                <Spinner />
                                :
                                <h4
                                    className='blue-text text-nowrap'
                                    style={{ fontSize: '15px' }}
                                >
                                    {Number(parseMillisecondsToHoursAndMinutes(totals.hs_50).split(':')[0])}hs {Number(parseMillisecondsToHoursAndMinutes(totals.hs_50).split(':')[1])}min
                                </h4>
                        }
                    </div>
                    <div className='text-center'>
                        <span
                            className={`subtitle text-nowrap ${isFetching && ('d-block')}`}
                        >
                            {t('100%_HS')}
                        </span>
                        {
                            isFetching ?
                                <Spinner />
                                :
                                <h4
                                    className='blue-text text-nowrap'
                                    style={{ fontSize: '15px' }}
                                >
                                    {Number(parseMillisecondsToHoursAndMinutes(totals.hs_100).split(':')[0])}hs {Number(parseMillisecondsToHoursAndMinutes(totals.hs_100).split(':')[1])}min
                                </h4>
                        }
                    </div>
                </div>
                {haveDetail && (
                    <div
                        className='border border-2 border-light-subtle bg-white rounded-circle position-absolute d-flex justify-content-center align-items-center'
                        style={{ top: '23%', right: '-15px', width: '32px', height: '32px' }}
                        type='button'
                        onClick={() => setShowModal(!showModal)}
                    >
                        <i
                            style={{ color: '#98A0B6' }}
                            className="fa-solid fa-chevron-right"
                        >
                        </i>
                    </div>
                )}
            </div>
        </>
    )
}

export default PermanenceTotals